<template>
  <div id="top" class="body">
    <Top />

    <div role="main" class="main">
      <section class="hero">
        <div class="hero-content">
          <p class="hero-tag">TECHNOLOGY x TRUST x GROWTH</p>
          <h1>InnoSource株式会社</h1>
          <p>
            ITソリューション事業を軸に、システム開発・運用保守・BPO支援・中国ソリューションまで、
            現場価値に直結するテクノロジーを提供します。
          </p>
          <div class="cta-group">
            <router-link to="/service" class="btn-tech primary">サービスを見る</router-link>
            <router-link to="/inquiries" class="btn-tech">お問い合わせ</router-link>
          </div>
        </div>
      </section>

      <section class="grid-cards">
        <article class="tech-card">
          <h3>システム開発</h3>
          <p>
            最先端の技術力を持つ技術者集団で、高い機動力とマネジメント力によって、
            お客様にとってより満足度の高いシステムをご提供しています。
          </p>
        </article>
        <article class="tech-card">
          <h3>システム運用保守</h3>
          <p>
            主に金融・流通・物流関係の業種で実績を積み重ね、特に証券・金融業界を得意とし、
            安定運用と継続改善を実現します。
          </p>
        </article>
        <article class="tech-card">
          <h3>ICT活用のBPO支援</h3>
          <p>
            最適な業務フローを設計し、「システム」と「BPO」をセットで提供。
            業務効率化とミス軽減を実務レベルで支援します。
          </p>
        </article>
        <article class="tech-card">
          <h3>中国ソリューション</h3>
          <p>
            中国の優れたITソリューションを発掘し、現地企業との連携を通して
            日本市場へ実践的なサービスを展開します。
          </p>
        </article>
      </section>

      <section class="dual-panel">
        <article class="panel">
          <img src="/vfront/img/office.png" alt="Business" />
          <div class="panel-body">
            <h2>Business 事業概要</h2>
            <p>
              InnoSource株式会社はITソリューション事業を軸とし幅広い領域で事業展開を行い、
              インターネットを介して人とメディアを繋ぐITソリューション企業です。
            </p>
            <router-link to="/business" class="btn-tech">MORE</router-link>
          </div>
        </article>

        <article class="panel">
          <img src="/vfront/img/recruit.png" alt="Recruit" />
          <div class="panel-body">
            <h2>Recruiting 社員募集</h2>
            <p>
              業務拡張に伴い、活力ある人材を募集しております。私たちのビジョンに共感し、
              共に成長してくださる方のご応募をお待ちしております。
            </p>
            <router-link to="/recruit" class="btn-tech">MORE</router-link>
          </div>
        </article>
      </section>

      <section class="stat-band" aria-label="実績データ">
        <article class="stat-item">
          <p class="stat-value">10+</p>
          <p class="stat-label">対応業種</p>
        </article>
        <article class="stat-item">
          <p class="stat-value">24/7</p>
          <p class="stat-label">運用監視体制</p>
        </article>
        <article class="stat-item">
          <p class="stat-value">100+</p>
          <p class="stat-label">参画エンジニア</p>
        </article>
        <article class="stat-item">
          <p class="stat-value">99.9%</p>
          <p class="stat-label">高可用性を目指す設計</p>
        </article>
      </section>

      <section class="delivery-flow">
        <div class="section-heading">
          <p>DELIVERY FLOW</p>
          <h2>価値提供までのプロセス</h2>
        </div>
        <div class="flow-grid">
          <article class="flow-card">
            <span>01</span>
            <h3>課題の整理</h3>
            <p>事業課題と現場の運用実態を可視化し、要件を整理します。</p>
          </article>
          <article class="flow-card">
            <span>02</span>
            <h3>設計と実装</h3>
            <p>拡張性と保守性を重視した設計で、最適なシステムを実装します。</p>
          </article>
          <article class="flow-card">
            <span>03</span>
            <h3>運用と改善</h3>
            <p>稼働後の監視・保守・改善サイクルで継続的な価値向上を実現します。</p>
          </article>
        </div>
      </section>

      <section class="coverage-section">
        <div class="section-heading">
          <p>CAPABILITY MAP</p>
          <h2>技術と業務領域のカバレッジ</h2>
        </div>
        <div class="coverage-grid">
          <article class="coverage-panel">
            <h3>対応業務領域</h3>
            <ul>
              <li>金融・証券向け基幹システム</li>
              <li>物流・流通向け業務最適化</li>
              <li>バックオフィスのBPO連携</li>
              <li>日中連携のITサービス導入支援</li>
            </ul>
          </article>
          <article class="coverage-panel">
            <h3>技術アセット</h3>
            <div class="chip-group">
              <span>Cloud Native</span>
              <span>API Integration</span>
              <span>Data Pipeline</span>
              <span>Operations Automation</span>
              <span>Security by Design</span>
              <span>BPO + System</span>
            </div>
          </article>
        </div>
      </section>

      <section class="home-cta">
        <h2>次の成長を、実装できる形へ。</h2>
        <p>
          企画段階の相談から、開発・運用・改善までワンストップで伴走します。
          InnoSource株式会社が、現場に機能するIT変革を支えます。
        </p>
        <div class="cta-group">
          <router-link to="/profile" class="btn-tech">会社情報を見る</router-link>
          <router-link to="/inquiries" class="btn-tech primary">相談を始める</router-link>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';

export default {
  name: 'Home',
  components: {
    Top,
    Foot,
  },
};
</script>

<style scoped>
.hero-tag {
  display: inline-block;
  padding: 0.3rem 0.7rem;
  border: 1px solid rgba(135, 190, 255, 0.5);
  border-radius: 999px;
  font-size: 0.75rem;
  letter-spacing: 0.12em;
  color: #bfe8ff;
  margin: 0 0 0.7rem;
}

.section-heading {
  margin-bottom: 1.2rem;
}

.section-heading p {
  margin: 0 0 0.4rem;
  letter-spacing: 0.12em;
  font-size: 0.78rem;
  color: #8ecbf0;
}

.section-heading h2 {
  margin: 0;
  font-size: 1.65rem;
  color: #f2f8ff;
}

.stat-band {
  width: min(100% - 2rem, var(--max));
  margin: 1.2rem auto 1.4rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8rem;
}

.stat-item {
  border: 1px solid rgba(146, 204, 255, 0.18);
  background: linear-gradient(150deg, rgba(14, 26, 44, 0.88), rgba(9, 18, 32, 0.9));
  border-radius: 14px;
  padding: 1rem 1rem 0.9rem;
}

.stat-value {
  margin: 0;
  font-size: 1.7rem;
  font-weight: 700;
  color: #d6eeff;
}

.stat-label {
  margin: 0.25rem 0 0;
  font-size: 0.92rem;
  color: #a9c7df;
}

.delivery-flow,
.coverage-section {
  width: min(100% - 2rem, var(--max));
  margin: 1rem auto 1.5rem;
  border: 1px solid rgba(145, 201, 255, 0.14);
  border-radius: 20px;
  background: linear-gradient(150deg, rgba(16, 30, 48, 0.8), rgba(9, 20, 35, 0.88));
  padding: 1.4rem;
}

.flow-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
}

.flow-card {
  border: 1px solid rgba(128, 190, 248, 0.16);
  background: rgba(7, 14, 25, 0.65);
  border-radius: 12px;
  padding: 0.95rem;
}

.flow-card span {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #04121f;
  background: linear-gradient(120deg, #7ad3ff, #a4e0ff);
}

.flow-card h3 {
  margin: 0.7rem 0 0.5rem;
  font-size: 1.02rem;
  color: #edf6ff;
}

.flow-card p {
  margin: 0;
  color: #aec9de;
  line-height: 1.7;
}

.coverage-grid {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 0.9rem;
}

.coverage-panel {
  border: 1px solid rgba(131, 194, 255, 0.16);
  border-radius: 12px;
  background: rgba(7, 14, 25, 0.62);
  padding: 1rem;
}

.coverage-panel h3 {
  margin: 0 0 0.65rem;
  color: #edf6ff;
  font-size: 1.02rem;
}

.coverage-panel ul {
  margin: 0;
  padding-left: 1.1rem;
  color: #abc8dd;
  line-height: 1.8;
}

.chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.chip-group span {
  border: 1px solid rgba(125, 188, 245, 0.28);
  background: rgba(14, 28, 45, 0.85);
  color: #d3ebfd;
  border-radius: 999px;
  padding: 0.35rem 0.7rem;
  font-size: 0.84rem;
}

.home-cta {
  width: min(100% - 2rem, var(--max));
  margin: 1rem auto 2.2rem;
  text-align: center;
  border: 1px solid rgba(140, 200, 255, 0.26);
  border-radius: 20px;
  padding: 2rem 1.2rem;
  background:
    radial-gradient(circle at 15% 20%, rgba(77, 168, 255, 0.18), transparent 40%),
    linear-gradient(150deg, rgba(16, 28, 46, 0.88), rgba(9, 19, 35, 0.92));
}

.home-cta h2 {
  margin: 0;
  color: #f3f9ff;
  font-size: 1.9rem;
}

.home-cta p {
  margin: 0.9rem auto 1.2rem;
  color: #acc9df;
  line-height: 1.8;
  max-width: 720px;
}

@media (max-width: 900px) {
  .stat-band {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .flow-grid,
  .coverage-grid {
    grid-template-columns: 1fr;
  }

  .home-cta h2 {
    font-size: 1.45rem;
  }
}

@media (max-width: 560px) {
  .stat-band {
    grid-template-columns: 1fr;
  }
}
</style>
